export const requisites = {
    ogrn: '1185027017240',
    inn: '5003129594',
    kpp: '500301001',
    okpo: '32487601',
    oktao: '46407000191',
    okfs: '16, Частная собственность',
    oktmo: '46707000291',
    okogu: '4210014',
    okopf: '12300',
    registration_data: '17.08.2018',
    ur_address: '142717, Московская область, город Видное, поселок Развилка, д. 45, ком. 2 ',
}

export const contacts = {
    sales_department_phone: '78003501390',
    commerce_department_phone: '79014172566',
    logistics_department_phone: '74993257566',
    info_mail: 'metalloprokatcompany@yandex.ru',
    whatsapp: 'https://api.whatsapp.com/send/?phone=79255491799&text&type=phone_number&app_absent=0',
    telegram: 'https://t.me/mprokat1',
    max: 'https://max.ru/u/f9LHodD0cOL_Bvsr9chc4MsM-Aml6U600SvNHM_JFV_EznH-nItcigW1ybo',
    yandex_map_link: 'https://yandex.com/maps/-/CLqCrE4H',
    address: 'Москва, посёлок Совхоза имени Ленина, Каширское шоссе, 23-й километр, 2, корп. 1',
}
